(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const stickyBar = document.getElementById('StickyATC');
    if (!stickyBar) return;

    const stickyPrice = document.getElementById('StickyATCPrice');
    const stickyImage = document.getElementById('StickyATCImage');
    const stickyVariantId = document.getElementById('StickyVariantId');
    const stickyButton = document.getElementById('StickyATCButton');

    const selectors = document.querySelectorAll('.sticky-variant-selector');

    const productForm = document.querySelector('form[action="/cart/add"]');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('active');
          } else {
            stickyBar.classList.remove('active');
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "-400px 0px 0px 0px"
      }
    );

    if (productForm) observer.observe(productForm);

    function getSelectedOptions() {
      return Array.from(selectors).map((select) => select.value);
    }

    function updateButtonState(variant) {
      if (!variant || !variant.available) {
        stickyButton.textContent = 'Sold Out';
        stickyButton.disabled = true;
      } else {
        stickyButton.textContent = 'Add to cart';
        stickyButton.disabled = false;
      }
    }

    function updateVariantAvailability() {
      const selectedOptions = getSelectedOptions();

      selectors.forEach((select, optionIndex) => {
        Array.from(select.options).forEach((option) => {
          const testOptions = [...selectedOptions];
          testOptions[optionIndex] = option.value;

          const matchingVariant = window.productVariants.find((variant) => {
            return variant.options.every((opt, i) => opt === testOptions[i]);
          });

          if (!matchingVariant || !matchingVariant.available) {
            option.disabled = true;
          } else {
            option.disabled = false;
          }
        });
      });
    }

    function findVariant() {
      const selectedOptions = getSelectedOptions();

      const variant = window.productVariants.find((v) => {
        return v.options.every((opt, index) => opt === selectedOptions[index]);
      });

      if (!variant) return;

      stickyVariantId.value = variant.id;

      if (stickyPrice) {
        stickyPrice.innerHTML = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
      }

      if (variant.featured_image && stickyImage) {
        stickyImage.src = variant.featured_image.src;
      }

      updateButtonState(variant);
      updateVariantAvailability();

      syncMainForm(variant.id);
    }

    selectors.forEach((select) => {
      select.addEventListener('change', findVariant);
    });

    function syncMainForm(variantId) {
      const variant = window.productVariants.find((v) => v.id == variantId);

      if (!variant) return;

      const productForm = document.querySelector('form[action="/cart/add"]');
      if (!productForm) return;

      variant.options.forEach((value, index) => {
        const optionInputs = productForm.querySelectorAll(
          `[name="options[${index + 1}]"], [data-index="option${index + 1}"]`
        );

        optionInputs.forEach((input) => {
          if (input.value === value) {
            if (input.type === 'radio') {
              input.checked = true;
            } else {
              input.value = value;
            }

            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    document.addEventListener('variant:change', function (evt) {
      const variant = evt.detail.variant;

      if (!variant) return;

      stickyVariantId.value = variant.id;

      selectors.forEach((select, index) => {
        select.value = variant.options[index];
      });

      if (stickyPrice) {
        stickyPrice.innerHTML = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
      }

      if (variant.featured_image && stickyImage) {
        stickyImage.src = variant.featured_image.src;
      }

      updateButtonState(variant);
      updateVariantAvailability();
    });

    // stickyButton.addEventListener('click', function () {
    //   if (stickyButton.disabled) return;

    //   const variantId = stickyVariantId.value;
    //   //   const quantity = document.getElementById('StickyATCQty').value;

    //   fetch('/cart/add.js', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       id: variantId,
    //       quantity: 1,
    //     }),
    //   })
    //     .then((res) => res.json())
    //     .then(() => {
    //       this.updateHeaderTotal();
    //       this.reloadCart();
    //       this.openPopdown(variant);
    //     });
    // });
    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled) return;

      const variantId = stickyVariantId.value;

      fetch(`${window.theme.routes.cart}/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((res) => res.json())
        .then((variant) => {
          fetch(`${window.theme.routes.cart}.js`)
            .then((res) => res.json())
            .then((cart) => {
              document.dispatchEvent(
                new CustomEvent('theme:cart:change', {
                  detail: { cart: cart },
                  bubbles: true,
                })
              );
            });

          document.dispatchEvent(
            new CustomEvent('theme:cart:reload', {
              bubbles: true,
            })
          );

          const popdown = document.querySelector('[data-product-add-popdown-wrapper]');
          if (popdown) {
            popdown.dispatchEvent(
              new CustomEvent('theme:cart:popdown', {
                detail: { variant: variant },
                bubbles: true,
              })
            );
          }
          stickyButton.classList.add('loading');
          stickyButton.innerHTML = 'Adding';
          stickyButton.disabled = true;

          productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
      document.addEventListener('theme:cart:change', function () {
        stickyButton.classList.remove('loading');
        stickyButton.disabled = false;
        stickyButton.innerHTML = 'Add To Cart';
      });
    });

    updateVariantAvailability();
  });
  } catch(e) { console.error(e); }
})();

})();
